module.exports = fox._r("fonts/robotocondensed-italic-webfont.woff", __webpack_public_path__ + "_/_/_/root/fonts/3OTg3kp.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/robotocondensed-italic-webfont.woff
// module id = 161
// module chunks = 4